export default __webpack_public_path__ + "static/media/8.72549b09.png";